import { Component, OnInit, ViewChild} from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UIRouter, Transition } from "@uirouter/angular";

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { AuditTrailService } from "../audit-trail-service/audit-trail.service"


@Component({
  selector: 'app-audit-trail-items',
  templateUrl: './audit-trail-items.component.html',
  styleUrls: ['./audit-trail-items.component.less']
})
export class AuditTrailItemsComponent implements OnInit {

	private auditTrailItems:Array<any>

  constructor(private router: UIRouter, private auditTrailService: AuditTrailService) { }

  ngOnInit() {

    if(this.router.stateService.$current.name == 'app.customerAudit'){

      this.auditTrailService.retrieveCustomerAuditTrail(this.router.globals.params.customerId);

      this.auditTrailService.auditTrailItems.subscribe((x)=>{
        
        this.auditTrailItems = x

      })

    }
    if(this.router.stateService.$current.name == 'app.staffAudit'){

      this.auditTrailService.retrieveStaffAuditTrail();

      this.auditTrailService.auditTrailItems.subscribe((x)=>{
        
        this.auditTrailItems = x

      })

    }

  	
  }

  markTaskAsComplete(id){

    this.auditTrailService.markTaskAsCompleted(id);

    this.auditTrailService.auditTrailItems.subscribe((x)=>{
      
      this.auditTrailItems = x

    })

}

}



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/audit-trail-items/audit-trail-items.component.ts